// wishListCardStyles
import { wishListCardStyles as styles } from "@insite/content-library/Components/WishListCard";
import { commonLinkStyles, customLinkHoverStyles } from "@solveindustrial/Utilities/styleguide";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.gridContainer = {
    ...styles.gridContainer,
    gap: 0,
    offsetCss: css`
        ${styles.gridContainer?.css}
        padding: 24px;
    `,
};

styles.productImageLink = {
    ...styles.productImageLink,
    css: css`
        ${styles.productImageLink?.css}
        width: 50px;
        height: 50px;

        ${mediaQueriesBP.minMD} {
            width: 75px;
            height: 75px;
        }
    `,
};

styles.actionAddToCartButton = {
    ...styles.actionAddToCartButton,
    color: "primary",
    css: css`
        ${styles.actionAddToCartButton?.css}
        min-height: 30px;
        height: 30px;
        padding: 0 10px;
        ${mediaQueriesBP.minMD} {
            min-height: 30px;
            height: 30px;
            padding: 0 10px;
        }
    `,
    mergeCss: true,
};

styles.detailLinkGridItem = {
    ...styles.detailLinkGridItem,
    css: css`
        ${styles.detailLinkGridItem?.css}

        a {
            ${commonLinkStyles}
            ${customLinkHoverStyles}
        }
    `,
};

styles.actionDeleteButton = {
    ...styles.actionDeleteButton,
    css: css`
        ${styles.actionDeleteButton?.css}
        min-height: 30px;
        height: 30px;
        padding: 0 10px;
        ${mediaQueriesBP.minMD} {
            min-height: 30px;
            height: 30px;
            padding: 0 10px;
        }
    `,
};

styles.actionGridMediumHidden = {
    ...styles.actionGridMediumHidden,
    css: css`
        ${styles.actionGridMediumHidden?.css}
        justify-content: space-around;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
    `,
};

styles.sharingStatus = {
    ...styles.sharingStatus,
    privateTooltip: {
        ...styles.sharingStatus?.privateTooltip,
        mergeCss: true,
    },
};
